var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-inline-alert',{attrs:{"type":"critical"}},[_c('span',{staticClass:"sms-invalid-character-alert"},[_vm._v(" "+_vm._s(_vm.$t('sms.broadcast.invalid.character.text1'))+" "),_c('strong',[_vm._v(_vm._s(_vm.$t('sms.broadcast.invalid.character.text2')))]),_vm._v(" "+_vm._s(_vm.$t('sms.broadcast.invalid.character.text3'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }